import { genders, states } from "~/data";
import { AuthUser } from "~/types";
import { useUpdateProfile } from "../hooks/update-profile";

interface PersonalDetailsFormProps {
  user: AuthUser | null | undefined
}

export function PersonalDetailsForm({
  user
}: PersonalDetailsFormProps) {
  const { form, onSubmit, isLoading } = useUpdateProfile({ user });

  const { register, handleSubmit, formState: { errors } } = form

  const handleFormSubmit = handleSubmit(async (data) => {
   
    await onSubmit(data);
  });

  return (
    <div className="p-6 bg-white shadow-md rounded-lg w-full lg:max-w-lg">
      <h2 className="text-2xl font-bold mb-6">Personal Details</h2>
      <form onSubmit={handleFormSubmit} className="space-y-4">
        <div className="flex gap-2 w-full">
          <div className="w-full">
            <label className="block text-sm font-medium" htmlFor="firstName">
              First Name
            </label>
            <input
              {...register("first_name")}
              type="text"
              id="first_name"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.first_name && (
              <p className="mt-1 text-sm text-red-600">{errors.first_name.message}</p>
            )}
          </div>
          <div className="w-full">
            <label className="block text-sm font-medium" htmlFor="lastName">
              Last Name
            </label>
            <input
              {...register("last_name")}
              type="text"
              id="last_name"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.last_name && (
              <p className="mt-1 text-sm text-red-600">{errors.last_name.message}</p>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium" htmlFor="email">
            Email
          </label>
          <input
            {...register("email")}
            type="email"
            id="email"
            className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium" htmlFor="phone">
            Phone
          </label>
          <input
            {...register("phone_number")}
            type="tel"
            id="phone"
            className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {errors.phone_number && (
            <p className="mt-1 text-sm text-red-600">{errors.phone_number.message}</p>
          )}
        </div>

        <div className="grid sm:grid-cols-3 gap-2 items-center">
          <div>
            <label className="block text-sm font-medium" htmlFor="state">
              State
            </label>
            <select
              {...register("state")}
              id="state"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {states.map((state) => (
                <option key={state.value} value={state.value}>
                  {state.label}
                </option>
              ))}
            </select>
            {errors.state && (
              <p className="mt-1 text-sm text-red-600">{errors.state.message}</p>
            )}
          </div>

          {/* <div>
            <label className="block text-sm font-medium" htmlFor="city">
              City
            </label>
            <select
              {...register("city")}
              id="city"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {cities.map((city) => (
                <option key={city.value} value={city.value}>
                  {city.label}
                </option>
              ))}
            </select>
            {errors.city && (
              <p className="mt-1 text-sm text-red-600">{errors.city.message}</p>
            )}
          </div> */}

          <div>
            <label className="block text-sm font-medium" htmlFor="dob">
              Date of Birth
            </label>
            <input
              {...register("date_of_birth")}
              type="date"
              id="date_of_birth"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.date_of_birth && (
              <p className="mt-1 text-sm text-red-600">{errors.date_of_birth.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium" htmlFor="gender">
              Gender
            </label>
            <select
              {...register("gender")}
              id="gender"
              className="w-full p-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {genders.map((gender) => (
                <option key={gender.value} value={gender.value}>
                  {gender.label}
                </option>
              ))}
            </select>
            {errors.gender && (
              <p className="mt-1 text-sm text-red-600">{errors.gender.message}</p>
            )}
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={isLoading}
            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default PersonalDetailsForm;
